import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/introduce/d_zycc.jpg'


const _withScopeId = n => (_pushScopeId("data-v-38d60910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_container_none_padding" }
const _hoisted_2 = { id: "btns" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "content_container" }, [
  /*#__PURE__*/_createElementVNode("p", null, " 归农用6年时间打造了一条成熟的数字化采购体系、品控标准体系、高效率供应链体系。以“中央仓储+万店同源”模式，构建了四大仓储中心。 "),
  /*#__PURE__*/_createElementVNode("p", null, " 仓储配送严格做好抽样检测、快递开箱体验优化等，实现成本控制与快递配送质量两者的平衡。 ")
], -1))
const _hoisted_4 = { id: "content_container" }
const _hoisted_5 = { id: "store_container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "store_center",
  src: _imports_0
}, null, -1))
const _hoisted_7 = { id: "stores" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomBtn = _resolveComponent("CustomBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btns, (item, index) => {
        return (_openBlock(), _createBlock(_component_CustomBtn, {
          key: index,
          config: item
        }, null, 8, ["config"]))
      }), 128))
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (item, index) => {
            return (_openBlock(), _createElementBlock("img", {
              id: "store",
              key: index,
              src: item.img
            }, null, 8, _hoisted_8))
          }), 128))
        ])
      ])
    ])
  ]))
}